<template>
  <div :class="{
    'box box-website builder-container-list-websites_card-box-websites': isCardView,
    'builder-container-list-websites_card-list-website': isListView
  }">
    <template v-if="isListView">
      <div v-if="selectWebsites" class="box-all-checked">
        <div class="form-check pl-0 pr-2">
          <input v-if="selectWebsites.type === 'all'" :checked="selectWebsites.type === 'all'" type="checkbox"
            @click.prevent="checkedSelectAll(config.id)">
          <input v-show="selectWebsites.type !== 'all'" :id="`selected-user-${config.id}`"
            v-model="selectWebsites.selectedWebsites" :value="config.id" type="checkbox" @change="changeUnitary()">
        </div>
      </div>
      <div
        :style="`background-image: url('${(pageHome.configuration && pageHome.configuration.og_image) ? pageHome.configuration.og_image : '/static/images/cheetah-og.png'}');`"
        class="card-list-image-container">
        <div v-if="pageHome && pageHome.url && website_type === 'websites'" class="card-list-image-upload-overlay">
          <router-link v-if="!pageHome.is_turbo" :to="{ name: 'editor', params: { page_id: pageHome.encrypted_id } }"
            class="btn-edit-website" target="_blank">{{ $t('ct-card-site-edit') }}
          </router-link>
        </div>
      </div>
      <website-info :config="config" :is-unpublish="isUnpublish" :website_type="website_type"
        class="card-list-info-container" />
      <div class="card-list-divisor" />
      <div v-if="isUnpublish" class="box-badge unpublished ba-mg-l-2 ba-mg-r-2">{{ $t('ct-unpublished') }}</div>
      <div v-else class="box-badge published ba-mg-l-2 ba-mg-r-2">{{ $t('ct-published') }}</div>
      <div class="card-list-divisor" />
      <website-actions :class="{ 'box-options': isCardView, 'card-list-options': isListView }" :config="config"
        :page-home="pageHome" :website_type="website_type" @publish="publish" @transfer="transfer" @unpublish="unpublish"
        @uploadImagePage="uploadImagePage" />
    </template>

    <template v-else>
      <div class="box-body">
        <div class="box-actions">
          <div v-if="selectWebsites" class="box-all-checked pl-0 pr-2">
            <input v-show="selectWebsites.type === 'all'" :checked="selectWebsites.type === 'all'" type="checkbox"
              @click.prevent="checkedSelectAll(config.id)">
            <input v-show="selectWebsites.type !== 'all'" :id="`selected-user-${config.id}`"
              v-model="selectWebsites.selectedWebsites" :value="config.id" type="checkbox" @change="changeUnitary()">
          </div>
          <!-- <div v-if="isUnpublish && !isMirror" class="box-badge-unpublish">{{ $t('ct-unpublished') }}</div> -->
          <div v-if="isUnpublish && !isMirror" class="box-badge unpublished">{{ $t('ct-unpublished') }}</div>
        </div>
        <div
          :style="`background-image: url('${(pageHome.configuration && pageHome.configuration.og_image) ? pageHome.configuration.og_image : '/static/images/cheetah-og.png'}');`"
          class="box-image-container">
          <div v-if="pageHome && pageHome.url && website_type === 'websites'" class="box-upload-overlay">
            <router-link v-if="!pageHome.is_turbo" :to="{ name: 'editor', params: { page_id: pageHome.encrypted_id } }"
              class="btn-edit-website" target="_blank">{{ $t('ct-card-site-edit') }}
            </router-link>
          </div>
        </div>
      </div>
      <div v-if="config" class="box-footer">
        <website-info :config="config" :is-unpublish="isUnpublish" :website_type="website_type" class="box-info" />
        <website-actions :class="{ 'box-options': isCardView, 'card-list-options': isListView }" :config="config"
          :page-home="pageHome" :website_type="website_type" @duplicate="duplicate" @publish="publish"
          @transfer="transfer" @unpublish="unpublish" @uploadImagePage="uploadImagePage" />
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import { duplicateWebsite, updateStatus } from './../../../../js/services/editor/website';
import WebsiteActions from "./websites/WebsiteActions.vue";
import WebsiteInfo from "./websites/WebsiteInfo.vue";

export default {
  name: 'SiteCardComponent',
  components: {
    WebsiteInfo,
    WebsiteActions,
  },

  props: ['website_type', 'config', 'categories', 'type_view', 'selectWebsites'],

  data() {
    return {
      pageHome: { configuration: {} }
    };
  },

  computed: {
    isUnpublish() {
      return this.config.status !== 'active';
    },

    isMirror() {
      return this.website_type === 'mirror';
    },

    isListView() {
      return this.type_view === 'list';
    },

    isCardView() {
      return this.type_view === 'card';
    }
  },

  watch: {
    config: function () {
      this.homePage();
    },
  },

  methods: {
    ...mapGetters({ getUser: 'user' }),
    updateWebsites() {
      this.$emit('updateWebsites');
    },

    checkedSelectAll(website_id) {
      this.$emit('checkedSelectAll', website_id);
    },

    changeUnitary() {
      this.$emit('changeUnitary');
    },

    uploadImagePage(page) {
      this.$emit('uploadImagePage', page);
    },

    unpublish(status = 'inactive') {
      let data = {
        encrypted_id: this.config.encrypted_id,
        status: status
      };

      this.updateStatus(data);
    },

    updateStatus(data) {
      this.$loading.show();

      updateStatus(data)
        .then(() => {
          this.$loading.hide();
          this.updateWebsites();
        })
        .catch(() => {
          this.$loading.hide();
          this.$snotify.error(
            'Something happened when trying to unpublish or publish your site, check the settings'
          );
        });
    },

    duplicate() {
      this.$loading.show();

      duplicateWebsite(this.config)
        .then(data => {
          if (data.data.success === false)
            this.$snotify.warning(this.$t(data.data.error));

          this.updateWebsites();
          this.$snotify.success(this.$t('ct-duplicate-success'));
        })
        .catch(error => {
          if (error.response) {
            // Request made and server responded
            if (error.response.status === 429) { // to many
              this.$snotify.error(this.$t('ct-too-many-attempts'));
            }
          }
        })
        .finally(() => this.$loading.hide());
    },

    transfer(show, config = '') {
      this.$emit('transfer', show, config);
    },

    publish(show) {
      this.$emit('publish', show, this.config);
    },

    getPageHome(data) {
      return data.find(page => !!page.initial);
    },

    homePage() {
      if (this.config.layouts && this.config.layouts[0] && this.config.layouts[0].pages && this.config.layouts[0].pages.length > 0) {
        let home = this.getPageHome(this.config.layouts[0].pages);
        this.pageHome = home || this.config.layouts[0].pages[0];
      }
    },
  },
  mounted() {
    this.homePage();
  }
};
</script>



// WEBPACK FOOTER //
// src/components/dashboard/layout/site/SiteCard.vue